import React from 'react';

import StartCard from './StartCard';
import PersonalCard from './PersonalCard';
import ContactCard from './ContactCard';
import FamilyCard from './FamilyCard';
import ChurchCard from './ChurchCard';
import DocumentCard from './DocumentCard';
import PhotoCard from './PhotoCard';
import SendCard from './SendCard';
import CloseCard from './CloseCard';

const cards = {
  start: <StartCard name='start' />,
  photo: <PhotoCard name='photo' />,
  personal: <PersonalCard name='personal' />,
  contact: <ContactCard name='contact' />,
  family: <FamilyCard name='family' />,
  church: <ChurchCard name='church' />,
  document: <DocumentCard name='document' />,
  send: <SendCard name='send' />,
  close: <CloseCard name='close' />,
};

const list = ['start', 'photo', 'personal', 'contact', 'family', 'church', 'document', 'send', 'close'];
const wizard = { cards, list };

export { cards, list };

export default wizard;
